import { DrawType } from '@apply/constants';
import { BorrowerRequestBudgetDrawPanel } from './BorrowerRequestBudgetDrawPanel';
import { BorrowerSubmittedAwaitingInspectionOrderDrawPanel } from './BorrowerSubmittedAwaitingInspectionOrderDrawPanel';
import { BudgetNoDrawsDrawPanel } from './BudgetNoDrawsDrawPanel';
import { DefaultDrawPanel } from './DefaultDrawPanel';
import { FundedBudgetDrawPanel } from './FundedBudgetDrawPanel';
import { InpectingBudgetDrawPanel } from './InpectingBudgetDrawPanel';
import { NoBudgetDrawPanel } from './NoBudgetDrawPanel';
import { ReadOnlyDrawPanel } from './ReadOnlyDrawPanel';
import { DrawHistoryGrid } from './DrawHistoryGrid';
import { LoanStatusType } from '../../../common/LoanConstants';

export const DrawPanel = ({ property, statusId, styles, validateSubmission, onProblemPropertyChange }) => {
    const latestDraw = property?.drawHistoryLines?.length && property?.drawHistoryLines[property?.drawHistoryLines?.length - 1];
    const hasNoBudget = !property.drawBudgetId;
    const isReadOnly = ![LoanStatusType.Outstanding, LoanStatusType.Approved].includes(statusId);

    const hasNoDraws = (property?.drawHistoryLines?.length ?? 0) === 0;

    const isBorrowerRequest =
        latestDraw?.drawType === DrawType.Manual &&
        latestDraw?.borrowerRequested &&
        !latestDraw?.borrowerSubmitted &&
        !latestDraw?.inspectionOrdered &&
        !latestDraw?.inspectedOn &&
        !latestDraw?.fundedOn;

    const isAwaitingInspectionOrder =
        latestDraw?.borrowerRequested &&
        (latestDraw?.drawType === DrawType.Automatic ||
            (latestDraw?.drawType === DrawType.Manual && latestDraw?.borrowerSubmitted === true)) &&
        !latestDraw?.inspectionOrdered &&
        !latestDraw?.inspectedOn &&
        !latestDraw?.fundedOn;

    const isInspecting =
        latestDraw?.borrowerRequested && latestDraw?.inspectionOrdered && !latestDraw?.inspectedOn && !latestDraw?.fundedOn;

    const isFunded =
        latestDraw?.borrowerRequested && latestDraw?.inspectionOrdered && latestDraw?.inspectedOn && latestDraw?.fundedOn;
    const isNewDrawAllowableStatus = statusId === LoanStatusType.Outstanding;

    const Panel = () => {
        if (isReadOnly) {
            return (
                <ReadOnlyDrawPanel
                    property={property}
                    styles={styles}
                    validateSubmission={validateSubmission}
                    onProblemPropertyChange={onProblemPropertyChange}
                    budgetExists={!hasNoBudget}
                />
            );
        }
        if (hasNoBudget)
            return (
                <NoBudgetDrawPanel
                    property={property}
                    styles={styles}
                    validateSubmission={validateSubmission}
                    onProblemPropertyChange={onProblemPropertyChange}
                />
            );

        if (!isNewDrawAllowableStatus)
            return (
                <DefaultDrawPanel
                    property={property}
                    styles={styles}
                    validateSubmission={validateSubmission}
                    onProblemPropertyChange={onProblemPropertyChange}
                />
            );

        if (hasNoDraws)
            return (
                <BudgetNoDrawsDrawPanel
                    property={property}
                    styles={styles}
                    validateSubmission={validateSubmission}
                    onProblemPropertyChange={onProblemPropertyChange}
                />
            );

        if (isBorrowerRequest)
            return (
                <BorrowerRequestBudgetDrawPanel
                    property={property}
                    styles={styles}
                    validateSubmission={validateSubmission}
                    onProblemPropertyChange={onProblemPropertyChange}
                />
            );

        if (isAwaitingInspectionOrder)
            return (
                <BorrowerSubmittedAwaitingInspectionOrderDrawPanel
                    property={property}
                    styles={styles}
                    validateSubmission={validateSubmission}
                    onProblemPropertyChange={onProblemPropertyChange}
                />
            );

        if (isInspecting)
            return (
                <InpectingBudgetDrawPanel
                    property={property}
                    styles={styles}
                    validateSubmission={validateSubmission}
                    onProblemPropertyChange={onProblemPropertyChange}
                />
            );

        if (isFunded)
            return (
                <FundedBudgetDrawPanel
                    property={property}
                    styles={styles}
                    validateSubmission={validateSubmission}
                    onProblemPropertyChange={onProblemPropertyChange}
                />
            );

        return (
            <DefaultDrawPanel
                property={property}
                styles={styles}
                validateSubmission={validateSubmission}
                onProblemPropertyChange={onProblemPropertyChange}
            />
        );
    };

    return (
        <>
            <h2
                className='decorated'
                style={styles.sectionHeader}
            >
                Draws
            </h2>
            <Panel />
            {!hasNoBudget && <DrawHistoryGrid property={property} />}
        </>
    );
};
